(function () {
  if (window.__ALMIRA_REL_POPUP_INIT__) return;
  window.__ALMIRA_REL_POPUP_INIT__ = true;

  var cache = {};

  var modal = document.createElement("div");
  modal.className = "almiraRelModal";
  modal.innerHTML =
    '<div class="almiraRelModal__backdrop" data-related-close></div>' +
    '<div class="almiraRelModal__panel" role="dialog" aria-modal="true" aria-label="Correlati">' +
      '<div data-related-content></div>' +
    '</div>';
  document.body.appendChild(modal);

  var content = modal.querySelector("[data-related-content]");
  var panel = modal.querySelector(".almiraRelModal__panel");

  function closeModal() {
    modal.classList.remove("is-open");
    content.innerHTML = "";
  }

  function initAutoReveal() {
    var grid = content.querySelector("[data-related-grid]");
    var sentinel = content.querySelector("[data-related-sentinel]");
    if (!grid || !sentinel) return;

    var batch = parseInt(grid.getAttribute("data-batch") || "8", 10) || 8;
    var busy = false;
    var observer = null;

    var itemObserver = null;

function ensureItemObserver() {
  if (itemObserver) return;

  itemObserver = new IntersectionObserver(function(entries){
    for (var x = 0; x < entries.length; x++) {
      if (entries[x].isIntersecting) {
        entries[x].target.classList.add("is-visible");
        itemObserver.unobserve(entries[x].target);
      }
    }
  }, {
    root: panel || null,
    rootMargin: "40px 0px 40px 0px",
    threshold: 0.15
  });
}

function observeItem(el){
  if (!el) return;
  ensureItemObserver();
  el.classList.add("almira-inview");    // stato “animabile”
  itemObserver.observe(el);
}

    function revealNext() {
      if (busy) return;
      busy = true;

      var hidden = grid.querySelectorAll("[data-related-item][hidden]");
      var i, shown = 0;

      for (i = 0; i < hidden.length && shown < batch; i++) {
        hidden[i].removeAttribute("hidden");

/* ✅ anima quando entra in viewport (stile Impulse) */
observeItem(hidden[i]);

shown++;
      }

      if (hidden.length <= batch) {
        try { sentinel.parentNode.removeChild(sentinel); } catch (e) {}
        if (observer) observer.disconnect();
      }

      // Impulse/AOS refresh se presente
      try {
        if (window.AOS && typeof window.AOS.refreshHard === "function") window.AOS.refreshHard();
        else if (window.AOS && typeof window.AOS.refresh === "function") window.AOS.refresh();
      } catch (e) {}

      busy = false;
    }

   observer = new IntersectionObserver(function (entries) {
  for (var k = 0; k < entries.length; k++) {
    if (entries[k].isIntersecting) revealNext();
  }
}, {
  root: panel,                           // ✅ usa lo scroll interno
  rootMargin: "400px 0px 400px 0px",     // ✅ carica prima
  threshold: 0
});

/* Fallback: se per qualche motivo panel non è lo scroll reale (iOS bug),
   riattacca observer su viewport dopo un attimo */
setTimeout(function () {
  // se siamo aperti e ancora ci sono hidden ma non ha mai caricato, fallback
  try {
    var stillHidden = grid.querySelectorAll("[data-related-item][hidden]").length;
    if (stillHidden > 0) {
      // re-observe su viewport (root null)
      observer.disconnect();
      observer = new IntersectionObserver(function (entries2) {
        for (var k2 = 0; k2 < entries2.length; k2++) {
          if (entries2[k2].isIntersecting) revealNext();
        }
      }, {
        root: null,
        rootMargin: "400px 0px 400px 0px",
        threshold: 0
      });
      observer.observe(sentinel);
    }
  } catch(e) {}
}, 600);

    observer.observe(sentinel);
    revealNext();
  }

  function openWithHtml(html) {
    content.innerHTML = html || "";
    modal.classList.add("is-open");
    initAutoReveal();

    // sync quickcart nel popup
    if (typeof window.__ALMIRA_QC_SYNC__ === "function") {
      window.__ALMIRA_QC_SYNC__();
    }
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-open-related]") : null;
    if (!btn) return;

    var handle = btn.getAttribute("data-related-handle");
    if (!handle) return;

    btn.disabled = true;

    if (cache[handle]) {
      openWithHtml(cache[handle]);
      btn.disabled = false;
      return;
    }

    var url = "/products/" + encodeURIComponent(handle) + "?view=almira_related_popup";

    fetch(url, { headers: { "Accept": "text/html" } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        cache[handle] = html;
        openWithHtml(html);
      })
      .catch(function () {
        closeModal();
      })
      .finally(function () {
        btn.disabled = false;
      });
  });

  document.addEventListener("click", function (e) {
    if (!modal.classList.contains("is-open")) return;
    var close = e.target.closest ? e.target.closest("[data-related-close]") : null;
    if (close) closeModal();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
  });
})();